import React from 'react';

// § I — Product Hero (the physical bottle leads)
import ProductHero from '../../components/Home/ProductHero';

// § II — Just Make It Exist First (three macro stills)
import MakeItExist from '../../components/Home/MakeItExist';

// § III — Vedic Biophysics banner (brand fades back, lives below the product)
import VedicBiophysicsBanner from '../../components/Philosophy/VedicBiophysicsBanner';

// § IV — Founding-edition physical-units counter
import GuardianLeaderboard from '../../components/Guardians/GuardianLeaderboard';

// § V — The 3K Trinity (Steel Blue)
import TrinityMacroBlocks from '../../components/Home/TrinityMacroBlocks';

// § VI — The Biological Ceasefire (Dark)
import BiologicalCeasefireBanner from '../../components/Home/BiologicalCeasefireBanner';

// § VII — Botanical Harmony (Powder Blue)
import BotanicalHarmony from '../../components/Home/BotanicalHarmony';

// § VIII — The Open Ledger (Receipt / Mono)
import OpenLedgerReceipt from '../../components/Home/OpenLedgerReceipt';

// § IX — The Agentic Stack (Atreya · Savitri · Indra)
import AgenticStack from '../../components/Philosophy/AgenticStack';

// Persistent advisor bubble
import AtreyaBubble from '../../components/Advisor/AtreyaBubble';

/**
 * Home — product-led architecture.
 *
 * Brand fades back. The 251 ml Miron Glass vessel + 100% Kewra Hydrosol
 * lead the page. Philosophy, 3K, harmony, ledger, agents all live
 * BELOW the product. The Vedic Biophysics gold banner — which used to
 * lead the page — now sits as a sovereign statement *after* the
 * product has done the talking.
 *
 *   § I    Product Hero           — 3D Miron vessel + Kewra still
 *   § II   Just Make It Exist     — three macro stills · Heavener atelier
 *   § III  Vedic Biophysics       — brand statement, secondary now
 *   § IV   Founding Edition       — reserved · shipped counters
 *   § V    The 3K Trinity         — Steel Blue
 *   § VI   Biological Ceasefire   — Dark contrast
 *   § VII  Botanical Harmony      — Powder Blue
 *   § VIII The Open Ledger        — Cream receipt
 *   § IX   The Agentic Stack      — Atreya · Savitri · Indra
 */
const HomePage = () => (
  <div data-testid="home-page">
    <ProductHero               testId="home-product-hero" />
    <MakeItExist               testId="home-make-it-exist" />
    <VedicBiophysicsBanner     testId="home-vedic-biophysics-banner" />
    <GuardianLeaderboard       testId="home-guardian-leaderboard" />
    <TrinityMacroBlocks        testId="home-trinity" />
    <BiologicalCeasefireBanner testId="home-ceasefire" />
    <BotanicalHarmony          testId="home-botanical-harmony" />
    <OpenLedgerReceipt         testId="home-open-ledger" />
    <AgenticStack              testId="home-agentic-stack" />
    <AtreyaBubble />
  </div>
);

export default HomePage;
